// BANAANPERZIK — Navegación de pantallas del menú móvil
document.addEventListener('DOMContentLoaded', function () {
  
  var root = document.querySelector('.bp-menu-mobile');
  if (!root) return;

  var level1 = root.querySelector('.bp-menu-level[data-level="1"]');
  var levels = root.querySelectorAll('.bp-menu-level[data-level]');
  var openers = root.querySelectorAll('.bp-menu-link');
  var backs   = root.querySelectorAll('.bp-back');
  var closes  = root.querySelectorAll('.bp-close');

  function openLevel(name) {
    levels.forEach(function (lv) {
      lv.classList.remove('bp-menu-level--active');
      lv.setAttribute('aria-hidden', 'true');
    });
    var target = root.querySelector('.bp-menu-level[data-name="' + name + '"]');
    (target || level1).classList.add('bp-menu-level--active');
    (target || level1).setAttribute('aria-hidden', 'false');
  }

  openers.forEach(function (btn) {
    btn.addEventListener('click', function () {
      openLevel(btn.getAttribute('data-target'));
    });
  });

  backs.forEach(function (btn) {
    btn.addEventListener('click', function () { openLevel(null); });
  });

  closes.forEach(function (btn) {
    btn.addEventListener('click', function () {
      // Cierra el drawer de Kalles (dialog#menu_mobile)
      var drawer = document.getElementById('menu_mobile');
      if (drawer && typeof drawer.close === 'function') drawer.close();
      else if (drawer) drawer.removeAttribute('open');
    });
  });

  // Si el drawer se vuelve a abrir, resetea a nivel 1
  document.addEventListener('hdt:drawer:open', function (e) {
    if (e && e.detail && e.detail.id === 'menu_mobile') openLevel(null);
  });
});
